import React, { Fragment } from 'react';
import { Route, Routes } from 'react-router-dom';
import WorkPackageList from './list/internals';
import WorkpackageDetail from './detail/internals';
import { ErrorBoundary, NotFound, useModulePermission } from '@bechtel/client-common';
import { WorkPackageDetailContainer } from './detail';
import { Alert } from '@bechtel/gds';
import { Trans } from '@lingui/macro';

// TODO: investigate bundle loss for not lazy loading these views
// NOTE: not lazy loading does have the benefit of increasing the responsiveness of this view
// however this will not be as necessary once the dashboard is completed
// const WorkPackageList = lazy(() => import('./list'));
// const WorkpackageDetail = lazy(() => import('./detail'));

const WorkPackages = () => {
  const { canViewWorkPackageModule } = useModulePermission();
  if (!canViewWorkPackageModule)
    return (
      <Alert>
        <Trans>Sorry, Work Package module is not activated for this project.</Trans>
      </Alert>
    );
  return (
    <Fragment>
      <ErrorBoundary>
        <Routes>
          <Route path="/" element={<WorkpackageDetail />} />
          <Route path={`/:id`} element={<WorkpackageDetail />} />
          <Route
            path="*"
            element={
              <WorkPackageDetailContainer>
                <NotFound />
              </WorkPackageDetailContainer>
            }
          />
        </Routes>
      </ErrorBoundary>
      <ErrorBoundary>
        <WorkPackageList />
      </ErrorBoundary>
    </Fragment>
  );
};

export default WorkPackages;
